import React, { useEffect, useRef, useState } from 'react';
import { Formik, Form } from 'formik';
import {
  Button,
  // Box,
  CircularProgress,
  Grid,
  Card,
  CardContent,
  CardHeader,
  CardActions,
  FormHelperText,
  Typography,
  // IconButton,
  // InputAdornment,
  TextField
  // Autocomplete,
  // Checkbox,
  // FormControlLabel
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import PaymentAction from '../../../store/actions/PaymentAction';
import PaymentLoader from '../../../utils/errorPages/PaymentLoader';
import CardImage from '../../../assets/images/card.png';
import { validationCloverForm } from '../../../assets/validation';

const CloverPaymentForm = ({ clientinfo, code }) => {
  const [cloverInstance, setCloverInstance] = useState(null);
  const [loading, setLoading] = useState(false);
  const [cardError, setCardError] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const elementsMounted = useRef(false);

  const initializeClover = () => {
    if (elementsMounted.current) return; // prevent duplicate mounting

    try {
      const clover = new window.Clover('ec51853f4ab025e4a182a505deac9876', {
        locale: 'en-us'
      });

      const elements = clover.elements();

      const styles = {
        body: {
          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
          // fontFamily: 'Nunito, sans-serif',
          fontSize: '16px'
        },
        input: {
          fontSize: '14px',
          margin: '0px',
          backgroundColor: 'transparent',
          border: '1px solid rgba(142,142,147,0.3)',
          borderRadius: '8px',
          padding: '12px 15px',
          minHeight: '56px'
        },
        'input:focus': {
          outline: 'none'
        }
      };

      elements.create('CARD_NUMBER', styles).mount('#card-number');
      elements.create('CARD_DATE', styles).mount('#card-date');
      elements.create('CARD_CVV', styles).mount('#card-cvv');
      elements.create('CARD_POSTAL_CODE', styles).mount('#card-postal-code');

      setCloverInstance(clover);
      elementsMounted.current = true;
    } catch (error) {
      console.error('Error initializing Clover:', error);
    }
  };

  useEffect(() => {
    if (window.Clover) {
      initializeClover();
    } else {
      console.error('Clover SDK not loaded');
    }

    return () => {
      const cardNumberEl = document.getElementById('card-number');
      if (cardNumberEl) cardNumberEl.innerHTML = '';
      const cardDateEl = document.getElementById('card-date');
      if (cardDateEl) cardDateEl.innerHTML = '';

      const cardCvvEl = document.getElementById('card-cvv');
      if (cardCvvEl) cardCvvEl.innerHTML = '';

      const cardPostalCodeEl = document.getElementById('card-postal-code');
      if (cardPostalCodeEl) cardPostalCodeEl.innerHTML = '';

      elementsMounted.current = false;
    };
  }, []);

  console.log(clientinfo, 'clientinfo');

  // const handleTokenCreation = async () => {
  //   if (!cloverInstance) return undefined;

  //   try {
  //     const result = await cloverInstance.createToken();

  //     if (result.errors) {
  //       console.error('Token errors:', result.errors);
  //       setCardError('Invalid card details');
  //       setIsTokenValid(false);
  //       return undefined;
  //     }

  //     if (result.token) {
  //       setIsTokenValid(true);
  //       setToken(result.token);
  //       return result.token;
  //     }

  //     setCardError('Token creation failed');
  //     return undefined;
  //   } catch (error) {
  //     console.error('Token creation error:', error);
  //     setCardError('Token creation error');
  //     return undefined;
  //   }
  // };

  const handleSubmit = async (values, { setErrors }) => {
    setCardError(''); // clear previous errors
    setLoading(true); // start submitting

    try {
      /* eslint-disable no-underscore-dangle */
      const result = await cloverInstance?.createToken(window._cloverElements);
      console.log('🚀 ~ handleSubmit ~ result:', result);

      if (result?.errors) {
        console.log('🚀 ~ handleSubmit ~ result.errors:', result.errors);
        setCardError(result.errors || 'Invalid card details');
        // ❌ don't stop submitting here
        return;
      }

      if (!result?.token) {
        console.log('🚀 ~ handleSubmit ~ result.token:', result.token);
        setCardError('Failed to generate token. Please check your card details.');
        // ❌ don't stop submitting here either
        return;
      }

      // eslint-disable-next-line camelcase
      const { address_zip, ...cardWithoutZip } = result.card || {};

      const newValues = {
        ...values,
        clover_token: result.token,
        ...cardWithoutZip
      };

      console.log('Form Values:', newValues);

      // ✅ Pass setSubmitting to redux action
      dispatch(PaymentAction.updateCloverCharge(code, newValues, setErrors, setLoading, navigate));
    } catch (err) {
      console.error('Error during submission:', err);
      setCardError('Unexpected error occurred. Please try again.');
      setLoading(false);
    }
  };

  // const handleSubmit = async (values, { setSubmitting, setErrors }) => {
  //   setCardError(''); // clear previous errors
  //   /* eslint-disable no-underscore-dangle */
  //   const result = await cloverInstance?.createToken(window._cloverElements);
  //   console.log('🚀 ~ handleSubmit ~ result:', result);
  //   if (result?.errors) {
  //     // Show specific field errors
  //     // const errorMessages = Object.values(result.errors).filter(Boolean).join(', ');
  //     console.log('🚀 ~ handleSubmit ~ result.errors:', result.errors);
  //     setCardError(result.errors || 'Invalid card details');
  //     setSubmitting(false);
  //     return;
  //   }

  //   if (!result?.token) {
  //     console.log('🚀 ~ handleSubmit ~ result.token:', result.token);

  //     setCardError('Failed to generate token. Please check your card details.');
  //     setSubmitting(false);
  //     return;
  //   }
  //   // eslint-disable-next-line camelcase
  //   const { address_zip, ...cardWithoutZip } = result.card || {};

  //   const newValues = {
  //     ...values,
  //     clover_token: result.token,
  //     ...cardWithoutZip
  //   };
  //   // Proceed with form submission
  //   console.log('Form Values:', newValues);
  //   dispatch(PaymentAction.updateCloverCharge(code, newValues, setErrors, setSubmitting, navigate));
  //   // Send to backend here
  // };

  return (
    <Formik
      initialValues={{
        first_name: clientinfo.first_name ?? '',
        last_name: clientinfo.last_name ?? '',
        email: clientinfo.email ?? '',
        phone: clientinfo.phone ?? ''
      }}
      enableReinitialize
      validationSchema={validationCloverForm}
      onSubmit={handleSubmit}
    >
      {({ values, errors, touched, handleChange, handleBlur, isSubmitting }) => {
        console.log(isSubmitting, 'isSubmitting');
        return (
          <Form id="paymentForm">
            {loading && <PaymentLoader />}
            <Card sx={{ mt: 2 }}>
              <CardHeader
                sx={{ textAlign: 'left' }}
                title="Credit Card Details"
                action={<img src={CardImage} alt="Credit Card" />}
              />
              <CardContent>
                <Grid container columnSpacing={2} rowSpacing={2}>
                  <Grid item lg={6} xl={6}>
                    <TextField
                      fullWidth
                      label="First Name"
                      name="first_name"
                      value={values.first_name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.first_name && Boolean(errors.first_name)}
                      helperText={touched.first_name && errors.first_name}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item lg={6} xl={6}>
                    <TextField
                      fullWidth
                      label="Last Name"
                      name="last_name"
                      value={values.last_name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.last_name && Boolean(errors.last_name)}
                      helperText={touched.last_name && errors.last_name}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item lg={6} xl={6}>
                    <TextField
                      fullWidth
                      label="Email"
                      name="email"
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.email && Boolean(errors.email)}
                      helperText={touched.email && errors.email}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item lg={6} xl={6}>
                    <TextField
                      fullWidth
                      label="Phone"
                      name="phone"
                      value={values.phone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.phone && Boolean(errors.phone)}
                      helperText={touched.phone && errors.phone}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item lg={12} xl={12}>
                    <Typography component="h2">Card Details</Typography>
                  </Grid>
                  <Grid item lg={6} xl={6}>
                    <div id="card-number" className="clover-element" />
                    {cardError?.CARD_NUMBER && (
                      <FormHelperText error>{cardError.CARD_NUMBER}</FormHelperText>
                    )}
                  </Grid>
                  <Grid item lg={6} xl={6}>
                    <div id="card-date" className="clover-element" />
                    {cardError?.CARD_DATE && (
                      <FormHelperText error>{cardError.CARD_DATE}</FormHelperText>
                    )}
                  </Grid>
                  <Grid item lg={6} xl={6}>
                    <div id="card-cvv" className="clover-element" />
                    {cardError?.CARD_CVV && (
                      <FormHelperText error>{cardError.CARD_CVV}</FormHelperText>
                    )}
                  </Grid>
                  <Grid item lg={6} xl={6}>
                    <div id="card-postal-code" className="clover-element" />
                    {cardError?.CARD_POSTAL_CODE && (
                      <FormHelperText error>{cardError.CARD_POSTAL_CODE}</FormHelperText>
                    )}
                  </Grid>
                </Grid>
                {/* {cardError && <FormHelperText error>{cardError}</FormHelperText>} */}
                <input type="hidden" name="intent_id" />
              </CardContent>
              <CardActions sx={{ justifyContent: 'center', py: '20px!important' }}>
                <Button
                  type="submit"
                  className="save__btn"
                  variant="contained"
                  color="secondary"
                  // fullWidth
                  disabled={isSubmitting}
                  size="large"
                >
                  {isSubmitting ? <CircularProgress size={20} /> : 'Submit'}
                </Button>
              </CardActions>
            </Card>
          </Form>
        );
      }}
    </Formik>
  );
};

CloverPaymentForm.propTypes = {
  code: PropTypes.string.isRequired,
  clientinfo: PropTypes.func.isRequired
};

export default CloverPaymentForm;
